import { PAGE_TYPES } from '../shared/utils/analytics/constants'

export const microPrefix = 'nol-portal-competition'

export function getPageType(slug) {
	if (slug === '/magazin/concursos/') return PAGE_TYPES.GENERIC

	return PAGE_TYPES.GENERIC
}
